export function briSimulateBuilderForUI(bri) {
  return {
    referenceId: bri.ReferenceId,
    maxPlafon: bri.MaxPlafon,
    status: bri.Status,
  };
}
